import React, { useState } from 'react';
import { t } from '../lib/i18n';
import { Share2, Link as LinkIcon, Check, MessageCircle, Facebook } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../lib/api';

export const catalogUrl = (deal) => `${window.location.origin}/catalogue/${deal.id}`;
export const shareCatalogUrl = (deal) => `${window.location.origin}/api/share/c/${deal.id}`;
const trackShare = (deal) => api.post(`/catalogs/${deal.id}/share`).catch(() => {});

const ShareMenu = ({ deal, variant = 'icon', view = null }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [mode, setMode] = useState('view');
  const useView = !!view && mode === 'view';
  const url = useView ? view.url : shareCatalogUrl(deal);
  const text = useView ? view.text : `Découvrez le catalogue ${deal.brand} sur DealRun !`;

  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

  const copy = async (e) => {
    stop(e);
    try {
      await navigator.clipboard.writeText(url);
      trackShare(deal);
      setCopied(true);
      toast.success('Lien copié !');
      setTimeout(() => { setCopied(false); setOpen(false); }, 1200);
    } catch (_) {
      toast.error('Impossible de copier le lien');
    }
  };

  const openShare = async (e) => {
    stop(e);
    if (navigator.share && variant === 'icon' && /Mobi|Android/i.test(navigator.userAgent)) {
      try { await navigator.share({ title: deal.brand, text, url }); trackShare(deal); return; } catch (_) { return; }
    }
    setOpen(!open);
  };
  const onNetworkClick = (e) => { e.stopPropagation(); trackShare(deal); setOpen(false); };

  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
  const facebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

  return (
    <div className="relative" onClick={stop}>
      {variant === 'icon' ? (
        <button data-testid="share-button" onClick={openShare} aria-label={t('Partager le catalogue')}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-black/40 backdrop-blur-sm hover:bg-black/60 transition-all active:scale-90">
          <Share2 size={16} className="text-white/80" />
        </button>
      ) : (
        <button data-testid="share-button" onClick={openShare}
          className="flex items-center gap-2 px-3 py-2 rounded-sm border border-[#262626] text-sm text-[#B3B3B3] hover:text-white hover:border-white/40">
          <Share2 size={16} /> {t('Partager le catalogue')}
        </button>
      )}
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={(e) => { stop(e); setOpen(false); }} />
          <div className="absolute right-0 top-11 z-50 w-60 bg-[#141414] border border-[#262626] rounded-md shadow-2xl py-1.5 text-left" data-testid="share-menu">
            {view && (
              <div className="mx-3 mb-1.5 grid grid-cols-2 gap-1 p-1 rounded-md bg-[#262626]" data-testid="share-mode">
                {[['view', t('Cette vue')], ['catalog', t('Catalogue complet')]].map(([m, label]) => (
                  <button key={m} onClick={(e) => { stop(e); setMode(m); }} data-testid={`share-mode-${m}`} aria-pressed={mode === m}
                    className={`px-2 py-1.5 rounded text-xs font-bold transition-colors ${mode === m ? 'bg-[#E50914] text-white' : 'text-[#B3B3B3] hover:text-white'}`}>{label}</button>
                ))}
              </div>
            )}
            <a href={whatsapp} target="_blank" rel="noopener noreferrer" onClick={onNetworkClick} data-testid="share-whatsapp"
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
              <span className="w-7 h-7 rounded-full bg-[#25D366] flex items-center justify-center text-white"><MessageCircle size={15} /></span> WhatsApp
            </a>
            <a href={facebook} target="_blank" rel="noopener noreferrer" onClick={onNetworkClick} data-testid="share-facebook"
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
              <span className="w-7 h-7 rounded-full bg-[#1877F2] flex items-center justify-center text-white"><Facebook size={15} /></span> Facebook
            </a>
            <button onClick={copy} data-testid="share-copy"
              className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
              <span className="w-7 h-7 rounded-full bg-[#262626] flex items-center justify-center text-white">{copied ? <Check size={15} className="text-emerald-400" /> : <LinkIcon size={15} />}</span>
              {copied ? t('Lien copié') : t('Copier le lien')}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareMenu;
